

function urlToRecuperarSenha(accountUrl, url, name) {
    const encodeQs = btoa(`redirectTo=${url}&redirectTitle=${name}&inscrevase=1`);
    return `${accountUrl}recuperar-senha?${encodeQs}`;
}

function openExternal(event, url) {
    event.preventDefault();
    window.open(url);
}

function encodeNavigateParameter(param) {
    if (!param)
        return param;
    if (param) {
        const enc = btoa(param);
        return encodeURI(enc);
    } else
        return param;
}

function decodeNavigateParameter(param) {
    if (!param)
        return param;
    const dec = decodeURI(param);
    if (dec) {
        let res = atob(dec);
        return res;
    } else
        return param;
}

function downloadFile(file, name) {
    const byteCharacters = atob(file);

    let byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);
    const a = document.createElement('a');
    a.style = 'display: none';
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
}

function openPdfNewTab(file) {
    openFileNewTab(file, "application/pdf");
}

function openFileNewTab(arquivo, extension) {
    const byteCharacters = atob(arquivo);

    let byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    //Create a Blob from the PDF Stream
    const file = new Blob([byteArray], { type: extension });
    //Build a URL from the file
    const fileURL = URL.createObjectURL(file);
    //Open the URL on new Window
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
}

function clone(obj) {
    return (JSON.parse(JSON.stringify(obj)));
}

function justNumber(value) {
    return value?.replace(/[^\d]+/g, '');
}

function filterArray(filter, array, key) {
    return filter.length > 0 ? array.filter(c => c[key]?.toLowerCase().indexOf(filter.toLowerCase()) !== -1) : array;
}

function blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

function cpfMask(value) {
    return value
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

export default {
    urlToRecuperarSenha,
    openExternal,
    encodeNavigateParameter,
    decodeNavigateParameter,
    downloadFile,
    clone,
    justNumber,
    openPdfNewTab,
    openFileNewTab,
    filterArray,
    blobToFile,
    cpfMask,
    groupBy
}